import {isNotNil} from 'ramda-adjunct';

import {Nullish, isNotNilOrZero, precisionCalculation} from 'shared/web';

const RATIO_DECIMAL_PLACES = 2;
const PERCENTAGE_BASE = 100;

export const getRatioFromAmount = (amount: number | Nullish, totalAmount: number | Nullish) =>
  isNotNil(amount) && isNotNilOrZero(totalAmount)
    ? precisionCalculation.round(
        precisionCalculation.multiply(
          precisionCalculation.divide(amount, totalAmount),
          PERCENTAGE_BASE
        ),
        RATIO_DECIMAL_PLACES
      )
    : null;
